// extracted by mini-css-extract-plugin
module.exports = {"contentStyles":"styles_contentStyles__1BNyT","image":"styles_image__2Kgjd","words":"styles_words__2heXB","placeholder":"styles_placeholder__1jeeo"};